import { InjectionToken } from '@angular/core'

export const InternalActionToken = new InjectionToken<Boo.Objects.InternalAction>('InternalAction');